module.exports = __webpack_public_path__ + "media/images/avatar/07-05b620f023a77d466f3449f48527f3a5.jpg";